import React from "react";
import {
  Star,
  Clock,
  Headphones,
  BookOpen,
  Heart,
  Sparkles,
  Smile,
  Wind,
  Award,
  Crown,
} from "lucide-react";

const BADGE_ICONS = {
  "Expert Listener": Headphones,
  "Great Storyteller": BookOpen,
  "Warm Soul": Heart,
  "Always On Time": Clock,
  "Genuine Friend": Sparkles,
  "Fun Energy": Smile,
  "Calm Presence": Wind,
  "Top Rated": Star,
  "Veteran": Crown,
};

const BADGE_TONE = {
  "Expert Listener": "bg-violet-100 text-violet-800",
  "Great Storyteller": "bg-amber-100 text-amber-800",
  "Warm Soul": "bg-rose-100 text-rose-800",
  "Always On Time": "bg-sky-100 text-sky-800",
  "Genuine Friend": "bg-emerald-100 text-emerald-800",
  "Fun Energy": "bg-orange-100 text-orange-800",
  "Calm Presence": "bg-teal-100 text-teal-800",
  "Top Rated": "bg-yellow-100 text-yellow-800",
  "Veteran": "bg-indigo-100 text-indigo-800",
};

export default function Badges({ badges = [], size = "sm" }) {
  if (!badges || badges.length === 0) return null;
  const small = size === "xs";
  return (
    <div className="flex flex-wrap gap-1.5" data-testid="badges-row">
      {badges.map((b) => {
        const Icon = BADGE_ICONS[b] || Award;
        return (
          <span
            key={b}
            className={`inline-flex items-center gap-1 ${BADGE_TONE[b] || "bg-stone-100 text-stone-700"} ${
              small ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-1"
            } font-semibold rounded-full`}
            data-testid={`badge-${b.replace(/\s+/g, "-").toLowerCase()}`}
          >
            <Icon className={small ? "h-2.5 w-2.5" : "h-3 w-3"} strokeWidth={2.5} /> {b}
          </span>
        );
      })}
    </div>
  );
}
